export default __webpack_public_path__ + "static/media/dropdown-down-arrow.0c032518.svg";